module.exports = __webpack_public_path__ + "static/media/dashboard-analytics-large.c0b45cdd.png";